module.exports = __webpack_public_path__ + "static/img/two_bg.9a0c3835.png";